export const isEmptyOrSpaces = (str) => {
  return (
    str == null ||
    str === "null" ||
    typeof str !== "string" ||
    (typeof str === "string" && str.match(/^ *$/) !== null)
  );
};
